<template>
  <div id="app">
    <div class="wp_loaderContainer" v-if="loading|prerender">
      <div class="wp_loader"></div>
    </div>
    <router-view v-else />
  </div>
</template>

<script>

export default {
	name: 'App',
	data () {
		return {
			loading: true,
			prerender: window.__PRERENDER__
		}
	},
	mounted () {
		this.loading = false
	}
}
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";
@import url("https://cdn.jsdelivr.net/npm/evil-icons@1.9.0/assets/evil-icons.min.css");
@import "../node_modules/vuejs-dialog/dist/vuejs-dialog.min.css";
@import "./assets/css/owl.carousel.min.css";
@import "./assets/css/owl.theme.default.min.css";
@import "../node_modules/vue-select/dist/vue-select.css";
@import "./assets/cms_templates_repo/components/progress-tracker";
@import "./assets/cms_templates_repo/main.scss";
</style>
